import React, { Component } from 'react';
import { Button, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';

class Snapshots extends Component {
  state = {
    catalogId: '',
    errorMessage: ''
  };

  downloadSnapshot = () => {
    const { catalogId } = this.state;

    // Don't change these params
    const fromS3 = true;
    const version = 'v2';
    // specify 1; this is not an image count; its a flag
    const images = 1;
    // include spreadsheet in the zip
    const includeXLS = true;

    // Configurable Params:
    // startImage #
    const startImage = 0;
    // endImage # - default is 500
    const endImage = 10000;
    // snapshotName - default is fine

    const urlPrefix = `/cps/app/snapshot/${catalogId}/lot-data`;

    const urlParamsRequired = `?includeXLS=${includeXLS}&fromS3=${fromS3}&version=${version}&images=${images}`;
    const urlParamsOptional = `&startImage=${startImage}&endImage=${endImage}`;

    window.location.href = `${urlPrefix}${urlParamsRequired}${urlParamsOptional}`;
  };

  handleInputChange = e => {
    const catalogId = e.target.value.trim();
    this.setState({ catalogId, errorMessage: '' });
  };

  // Catalog ID must be numerical
  validateInput = e => {
    const { value } = e.target;
    const numberRegex = /^[0-9]+$/;
    if (value.length > 0 && !numberRegex.test(value)) {
      this.setState({ errorMessage: 'Catalog ID must contain numbers only.' });
    }
  };

  render() {
    const { catalogId, errorMessage } = this.state;

    const hasError = errorMessage.length > 0;
    const disableButton = hasError || catalogId.length === 0;

    return (
      <Container className="py-4">
        <h1>Catalog Snapshot</h1>
        <p className="mt-4">
          Use this form to download a spreadsheet with lot descriptions and the associated lot
          images for an existing catalog.
        </p>
        <p>Enter the catalog id and click &quot;Download Snapshot&quot;.</p>

        <Row>
          <Col xs={6}>
            <FormGroup>
              <Label className="font-weight-bold" for="catalogId">
                Enter Catalog ID:
              </Label>
              <Input
                className={hasError ? 'is-invalid' : ''}
                id="catalogId"
                name="catalogId"
                onChange={e => this.handleInputChange(e)}
                onBlur={e => this.validateInput(e)}
                value={catalogId}
              />
              {hasError && <p className="color-danger mt-1">{errorMessage}</p>}
            </FormGroup>

            <Button
              color="primary"
              className={disableButton ? 'cursor-not-allowed' : ''}
              disabled={disableButton}
              onClick={() => this.downloadSnapshot()}
            >
              Download Snapshot
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Snapshots;
